// 表单验证

// 手机号码
export const validateMobile = (rule, val, callback) => {
    const reg = /^1\d{10}$/;
    if (!reg.test(val)) {
        callback(new Error("请输入正确的手机号码"));
    } else {
        callback();
    }
};

// 电话号码（手机+座机）
export const validateTel = (rule, val, callback) => {
    const reg1 = /^1[3456789]\d{9}$/;
    const reg2 = /^0\d{2,3}-?\d{7,8}$/;
    if (!reg1.test(val) && !reg2.test(val)) {
        callback(new Error("请输入正确的电话号码"));
    } else {
        callback();
    }
};

// 邮箱
export const validateEmail = (rule, val, callback) => {
    const reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
    if (val != null && val != "" && !reg.test(val)) {
        callback(new Error("请输入正确的邮箱"));
    } else {
        callback();
    }
};

// ip
export const validateIp = (rule, val, callback) => {
    const reg = /^(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/;
    if (val != null && val != "" && !reg.test(val)) {
        callback(new Error("请输入正确的ip地址"));
    } else {
        callback();
    }
};

// 端口
export const validatePort = (rule, val, callback) => {
    const reg = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/;
    if (val != null && val != "" && !reg.test(val)) {
        callback(new Error("请输入正确的端口号"));
    } else {
        callback();
    }
};